import { render, staticRenderFns } from "./ConsoleItem.vue?vue&type=template&id=ca4d0606&scoped=true&"
import script from "./ConsoleItem.vue?vue&type=script&lang=ts&"
export * from "./ConsoleItem.vue?vue&type=script&lang=ts&"
import style0 from "./ConsoleItem.vue?vue&type=style&index=0&id=ca4d0606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4d0606",
  null
  
)

export default component.exports